export default class Specialization {
  public static readonly SET_LIST = "COMPANY_SPECIALIZATION_SET_LIST";
  public static readonly SET_STATUS = "COMPANY_SPECIALIZATION_SET_STATUS";
  public static readonly SET_ERROR = "COMPANY_SPECIALIZATION_SET_ERROR";
  public static readonly CLEAR = "COMPANY_SPECIALIZATION_CLEAR";

  public static setList(data: any) {
    return {
      data,
      type: Specialization.SET_LIST,
    };
  }

  public static setStatus(data: any) {
    return {
      data,
      type: Specialization.SET_STATUS,
    };
  }

  public static setError(data: any) {
    return {
      data,
      type: Specialization.SET_ERROR,
    };
  }

  public static clear() {
    return {
      type: Specialization.CLEAR,
    };
  }
}
